import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/global.css'
import { initLocalLanguage } from './i18n/localLanguage'

Vue.config.productionTip = false

const app = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

initLocalLanguage(router)

export default app
